import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../core/Auth'
import { getFunctions, httpsCallable } from 'firebase/functions'
import { useDispatch } from 'react-redux'

const EmailVerification = () => {
  const [code, setCode] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [countdown, setCountdown] = useState(0)
  const navigate = useNavigate()
  const { currentUser } = useAuth()
  const dispatch = useDispatch()
  const functions = getFunctions()

  useEffect(() => {
    // Request verification code when component mounts
    requestVerificationCode()
  }, [])

  useEffect(() => {
    let timer: NodeJS.Timeout
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000)
    }
    return () => clearTimeout(timer)
  }, [countdown])

  const requestVerificationCode = async () => {
    try {
      setLoading(true)
      setError('')
      const generateCode = httpsCallable(functions, 'generateVerificationCode')
      await generateCode()
      setCountdown(180) // 3 minutes
    } catch (error: any) {
      setError(error.message)
    } finally {
      setLoading(false)
    }
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (code.length !== 6) {
      setError('Please enter a 6-digit code')
      return
    }

    try {
      setLoading(true)
      setError('')
      const validateCode = httpsCallable(functions, 'validateVerificationCode')
      const result:any = await validateCode({ code })
      
      if (result.data.success) {
        // Update user state in Redux
        //dispatch(updateUser({ ...currentUser, protected: { ...currentUser.protected, is_verified: true } }))
        // Redirect to dashboard
        //navigate('/dashboard')
      }
    } catch (error: any) {
      setError(error.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Verify Your Email</h3>
      </div>
      <div className="card-body">
        <p>Please enter the 6-digit verification code sent to your email.</p>
        
        <form onSubmit={handleSubmit}>
          <div className="mb-5">
            <input
              type="text"
              className="form-control"
              placeholder="Enter 6-digit code"
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
              disabled={loading}
            />
          </div>

          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}

          <div className="d-flex justify-content-between align-items-center">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading || countdown > 0}
            >
              {loading ? 'Verifying...' : 'Verify Code'}
            </button>

            <button
              type="button"
              className="btn btn-light"
              onClick={requestVerificationCode}
              disabled={loading || countdown > 0}
            >
              {countdown > 0 
                ? `Request new code in ${Math.floor(countdown / 60)}:${(countdown % 60).toString().padStart(2, '0')}`
                : 'Request new code'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default EmailVerification